import type { ModuleId } from '../content/content'
import { useKiosk } from '../state/store'
import { Automatisering } from './Automatisering'
import { Veiligheid } from './Veiligheid'
import { Energie } from './Energie'
import { Connectiviteit } from './Connectiviteit'
import { Infomodule } from './Infomodule'

/**
 * Modulescherm: de terugtegel en daarnaast het onderdeel zelf, volgens de
 * flowchart van 5 oktober (PLAN.md §0.8). Automatisering en Veiligheid hebben
 * een keuze met een film erachter; Energie is de calculator; Connectiviteit
 * is Warehouse Cockpit. Klantcases is op 6 oktober vervallen: het stond niet
 * in de flowchart. Stellingen en Tennant (21 oktober) zijn een infoscherm.
 */
export function Module({ id }: { id: ModuleId }) {
  switch (id) {
    case 'automatisering':
      return <Automatisering terug={<Terug />} />
    case 'veiligheid':
      return <Veiligheid terug={<Terug />} />
    case 'energie':
      return <Energie terug={<Terug />} />
    case 'connectiviteit':
      return <Connectiviteit terug={<Terug />} />
    case 'stellingen':
    case 'tennant':
      return <Infomodule id={id} terug={<Terug />} />
    default: {
      // Een onderdeel dat hier ontbreekt gaf stil een leeg scherm; zo weigert
      // de typecheck het.
      const vergeten: never = id
      return vergeten
    }
  }
}

/** De terugtegel, vooraan in de actiebalk van elk onderdeel. */
function Terug() {
  const taal = useKiosk((s) => s.taal)
  const ga = useKiosk((s) => s.ga)
  const vergrendeld = useKiosk((s) => s.vergrendeld)
  return (
    <button className="kiosk-tegel kiosk-tegel-terug" onClick={() => ga('hoofdscherm')} disabled={vergrendeld}>
      {/* Op de nummerregel van de andere tegels, zodat "Terug" op dezelfde
          hoogte staat als de namen ernaast. */}
      <span className="kiosk-tegel-nr" aria-hidden="true">←</span>
      <span className="kiosk-tegel-naam">{taal === 'nl' ? 'Terug' : 'Back'}</span>
      <span className="kiosk-tegel-sub">{taal === 'nl' ? 'naar het hoofdscherm' : 'to the main screen'}</span>
    </button>
  )
}
